module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_vestfold_telemark_neg.159914fa.png";